import WorkshopInitializer from '../../components/WorkshopInitializer.js';
import ReadMoreToggle from '../../components/readmore.js';
import EventFilter from '../../components/EventFilter.js';
import { initInstallmentAutoOpen } from '../../components/installment-auto-open.js';
import { domReady } from '../../utils/dom.js';
// Initialize contact modal system for waitlist/consultation buttons
import '../../contact/index.js';

/**
 * Initializes (or reuses) the shared global workshopApp.
 * Emits a ready event so other scripts can safely wait for it.
 */
function initWorkshopAppIfPresent() {
  const hasWorkshopData = document.getElementById('workshop-data');
  const hasGroupData = document.getElementById('group-data');
  const hasHhhData = document.getElementById('hhh-data');
  const hasIcmData = document.getElementById('icm-data');

  if (!hasWorkshopData && !hasGroupData && !hasHhhData && !hasIcmData) return null;

  // Idempotent: don't recreate if it already exists
  if (!window.workshopApp) {
    window.workshopApp = new WorkshopInitializer();

    // Allow other scripts to wait reliably without depending on load order
    window.dispatchEvent(
      new CustomEvent('workshopApp:ready', { detail: window.workshopApp })
    );
  }

  return window.workshopApp;
}

function initEventFilterIfPresent(config) {
  if (!document.querySelector(config.containerSelector)) return null;
  return new EventFilter(config);
}

initInstallmentAutoOpen();

domReady(() => {
  // Shared global used by other files
  initWorkshopAppIfPresent();

  // ReadMoreToggle is safe to initialize once DOM is ready
  new ReadMoreToggle();

  // DRY: declare filter configs and initialize only if the container exists
  const filterConfigs = [
    {
      containerSelector: '.workshop-events',
      itemSelector: '.workshop-group',
      visibleCountId: 'visible-workshops-count',
      totalCountId: 'total-workshops-count',
    },
    {
      containerSelector: '.hhh-events',
      itemSelector: '.hhh-group',
      visibleCountId: 'visible-hhh-count',
      totalCountId: 'total-hhh-count',
    },
    {
      containerSelector: '.icm-events',
      itemSelector: '.icm-group',
      visibleCountId: 'visible-icm-count',
      totalCountId: 'total-icm-count',
    },
  ];

  filterConfigs.forEach(initEventFilterIfPresent);
});
